import React from 'react';
import { Activation } from '../models/activation';
import { TRACKER_ACTIVATION_OVERVIEW_DRAFT_QUERY_MAPPING_CLICK } from '../tracking';
import { HdButton, HdLink, HdPane } from '../../../components';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { ActivatePreviewTab } from './models';

export function DraftQueryMessagePane({
  dataId,
  activation,
  selectedTab,
  selectTab,
  showChangeMappingDialog
}: {
  dataId: string;
  activation: Activation;
  selectedTab: ActivatePreviewTab;
  selectTab: Function;
  showChangeMappingDialog: Function;
}) {
  const dataIdGenerator = getDataIdGenerator(dataId);

  const { eventTrack } = useAnalyticsTracker();

  const draftQueryUpdateMappingClick = () => {
    eventTrack({
      action: TRACKER_ACTIVATION_OVERVIEW_DRAFT_QUERY_MAPPING_CLICK,
      properties: {
        activationId: activation.id
      }
    });

    showChangeMappingDialog();
  };

  return (
    <HdPane
      className='border-top'
      withoutBorder
      variant={selectedTab === ActivatePreviewTab.MAPPING ? 'info-faded' : 'warning-faded'}
      icon={selectedTab === ActivatePreviewTab.MAPPING ? 'info' : 'warning'}
      disableHide
    >
      <div className='center-flex-row justify-between'>
        <div className='text-medium'>
          {selectedTab === ActivatePreviewTab.MAPPING ? (
            <>
              The Query Fields displayed here are from your last saved query.{' '}
              To view the fields from your Draft SQL query, you must first map the new fields from the{' '}
              <HdLink
                tag='button'
                dataId={dataIdGenerator('map-fields-query-tab')}
                onClick={() => selectTab(ActivatePreviewTab.QUERY)}
              >
                Query tab
              </HdLink>
              .
            </>
          ) : (
            <>
              You have modified the query. To use this query in the Activation, you must map the new fields to the Target.
            </>
          )}
        </div>

        {selectedTab === ActivatePreviewTab.QUERY ? (
          <HdButton
            size='sm'
            palette='warning'
            icon='schema-mapper'
            onClick={draftQueryUpdateMappingClick}
            dataId={dataIdGenerator('map-new-fields')}
          >
            Map New Fields
          </HdButton>
        ) : null}
      </div>
    </HdPane>
  );
}
